(function () {
    'use strict';

    angular.module("imApp").factory("prodGrp4MenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 3083,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();